import { logEvent } from "../../utils/analytics";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import { BsArrowUpRight } from "react-icons/bs";
import PartyTag from "./PartyTag";
import { Link } from "react-router-dom";

const CandidatesGroup = ({ group, onSelectGroup }) => {

    const onCandidateClick = (candidate) => {
        logEvent('Candidates', 'Clicked candidate', candidate.name)
    }

    return (<div id={group.race} className="w-full flex flex-col md:scroll-mt-2 scroll-mt-[180px] bg-gray-100 border border-neutral-200 rounded-lg" >
        <button onClick={onSelectGroup} className="flex gap-0.5 items-end text-gray-600 px-2 py-3">
            <div className="flex flex-col items-start px-1 py-1">
                <h4 className="flex items-center gap-2">
                    <span className="text-base text-gray-700 text-sm">{group.title || group.role} </span>
                </h4>

                <span className="">
                    {/* <span className="text-sm text-gray-500">{group.name}: </span> */}
                    <span className="text text-gray-800 leading-none">{group.constituency}</span>
                </span>

            </div>

            <span className="ml-auto mb-2 mr-2">
                <span className={`rounded text-xs md:min-w-10 min-w-4 inline-flex items-center gap-1 px-2 py-1 justify-center font-bold transition-all text-white ${group.isActive ? "bg-black" : "bg-black/80 "}`}>
                    {group.total}

                    <span className="">{group.isActive ? <HiChevronUp /> : <HiChevronDown />}</span>
                </span>
            </span>
        </button>

        <div className={`flex-col transition-all border-t ${group.isActive ? 'visible flex' : 'invisible hidden'}`}>
            <Link to={group.articleRoute || group.resourceLink} target='_blank' className="flex items-center gap-1.5 text-xs px-2 py-1.5 bg-blue-100 hover:underline">
                What does {group.article || 'a'} {group.role} do? <BsArrowUpRight className="h-2.5" />
            </Link>

            {group.candidates.length
                ? <ul className="flex flex-col justify-center items-center flex-wrap gap-3 p-6">
                    {group.candidates.map((candidate) => (
                        <li className="w-full min-w-56 max-w-80 h-[144px]" key={candidate.name}>

                            <a
                            onClick={() => onCandidateClick(candidate)}
                            href={`https://www.google.com/search?q=${candidate.name}`}
                            target="_blank"
                            rel="noreferrer"
                             className="flex flex-col justify-between w-full h-full gap-0.5 px-3 bg-white border border-gray-100 shadow rounded-lg py-2.5">
                                <div className="flex flex-col h-full justify-between">
                                    <h5 className="text-lg leading-tight font-semibold">{candidate.name}</h5>

                                    <div>
                                        {candidate.isIncumbent && <span className="rounded text-xs px-1.5 py-0.5 bg-green-800 shadow text-white">Incumbent</span>}
                                    </div>
                                </div>

                                <div className="flex flex-col gap-2 border-t border-gray-100 pt-1">

                                    <div className="flex items-center justify-between">
                                        <div className="text-xs">
                                            <PartyTag party={candidate.partyCode} />
                                        </div>
                                        <div className={`text-xs rounded px-1.5 pb-px bg-${group.color}-50 text-${group.color}-600 capitalize`}>
                                            {group.role}
                                        </div>
                                    </div>
                                    <div className="">
                                        <p className="text-gray-500 text-[11px]">{group.runningMate || 'Running mate'}:</p>
                                        <h6 className="text-gray-600 text-sm text-nowrap truncate ellipsis leading-none">{candidate.runningMate || '-'}</h6>
                                    </div>
                                </div>
                            </a>
                        </li>
                    ))}
                </ul>
                : <div className="p-2 border border-gray-200 text-gray-500 rounded">
                    There are currently no {group.name.toLowerCase()} candidates
                </div>
            }</div>
    </div>)
}

export default CandidatesGroup;
